var styles = {
  "ExitActionWrapper": "Online-Store-UI-ExitAction__ExitActionWrapper_bh641",
  "ExitAction": "Online-Store-UI-ExitAction_1nt0s",
  "animated": "Online-Store-UI-ExitAction--animated_181lk",
  "Content": "Online-Store-UI-ExitAction__Content_1hg82",
  "Label": "Online-Store-UI-ExitAction__Label_pr60n",
  "IconWrapper": "Online-Store-UI-ExitAction__IconWrapper_j0xms",
  "ChildrenWrapper": "Online-Store-UI-ExitAction__ChildrenWrapper_er2ez"
};

export { styles as default };
